import PropTypes from 'prop-types';
import React from 'react';

import { Box, Typography } from '@mui/material';

import ProtectedData, { getSeverity, isProtectedData, LockIcon, UNKNOWN } from 'pages/components/ProtectedData';

import useStyles from './styles';

const COLORS_BACKGROUND = {
    High: '#FFEFEF',
    Medium: '#FFF3E4',
    Low: '#EAF9F7',
    [UNKNOWN]: '#F3F3F3'
};
const COLORS_ACCENT = {
    High: '#FF3306',
    Medium: '#FFC006',
    Low: '#82C4BB',
    [UNKNOWN]: '#E6E6E6'
};

const Score = ({ score, precision = 1, name = 'CVSS', className }) => {
    const { classes, cx } = useStyles();

    const severity = getSeverity(score, precision);

    return (
        <Box className={cx(classes.scorePane, className)} style={{ background: COLORS_BACKGROUND[severity] }}>
            <Box className={classes.container}>
                <div className={classes.scoreAccent} style={{ background: COLORS_ACCENT[severity] }} />
                <Typography className={classes.scoreText} variant="body1">
                    <ProtectedData data={score} />

                    <span className={classes.label}>
                        {isProtectedData(score) ? <LockIcon size={14} /> : null}
                        {name}
                    </span>
                </Typography>
            </Box>
        </Box>
    );
};

Score.propTypes = {
    score: PropTypes.number,
    precision: PropTypes.number,
    name: PropTypes.string,
    className: PropTypes.string
};

export default Score;
